// DEPENDENCIES
import React, { Suspense, lazy, useState, useEffect } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
// PAGES
import { useHistory } from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";
import UserListingPage from "./pages/users/UserListingPage";
import ClientListingPage from "./pages/clients/ClientListingPage";
import UserRegisterPage from "./pages/users/UserRegisterPage";
import TrainingTypesListingPage from "./pages/companyData/TrainingTypesListingPage";
import TrainingSubTypesListingPage from "./pages/companyData/TrainingSubTypesListingPage";
import IntervalTypesListingPage from "./pages/companyData/IntervalTypesListingPage";
import CredentialsListingPage from "./pages/training/CredentialsListingPage";
import CredentialDetailPage from "./pages/training/CredentialDetailPage";
import UserCredentialsListing from "./pages/training/UserCredentialsListing";
import UserCredentialDetailPage from "./pages/training/UserCredentialDetailPage";
import UserProfilePage from "./modules/UserProfile/UserProfilePage";
import ClientRegisterPage from "./pages/clients/ClientRegisterPage";
import PayRateListingPage from "./pages/management/PayRateListingPage";
import ClientDetailPage from "./pages/clients/ClientDetailPage";
import ProjectSubTypeListingPage from "./pages/companyData/ProjectSubTypesListingPage";
import ReferralSourceListingPage from "./pages/companyData/ReferralSourceListingPage";
import ProjectTypeListingPage from "./pages/companyData/ProjectTypesListingPage";
import ProposalDetailPage from "./pages/services/proposals/ProposalDetailPage";
import ProposalListingPage from "./pages/services/proposals/ProposalListingPage";
import SettingListingPage from "./pages/management/SettingListingPage";
import AnnualQuotaListingPage from "./pages/management/AnnualQuotaListingPage";
import YearTransitionPage from "./pages/management/YearTransitionPage";
import YearAllocationSettingsPage from "./pages/management/YearAllocationSettingsPage";
import AiDocumentManagerPage from "./pages/management/AiDocumentManagerPage";
import AutomatedReportListingPage from "./pages/management/automatedReports/automatedReportListingPage";
import AutomatedReportDetailPage from "./pages/management/automatedReports/automatedReportDetailPage";
import ProposalManagePage from "./pages/services/proposals/ProposalManagePage";
import EmployeeSearchPage from "./pages/training/EmployeeSearchPage";
import LogEventsPage from "./pages/logs/LogEventsPage";
import ProjectListingPage from "./pages/companyData/ProjectListingPage";
import TimeSheetPage from "./pages/users/TimeSheetPage";
import TimeLogReportPage from "./pages/reports/TimeLogReportPage";
import ProjectDetailPage from "./pages/companyData/project/ProjectDetailPage";
import FormListingPage from "./pages/forms/FormListingPage";
import CompanyCalendarPage from "./pages/companyData/CompanyCalendarPage";
import JobListingPage from "./pages/services/jobs/JobListingPage";
import JobListingCompletedPage from "./pages/services/jobs/JobListingCompletedPage";
import JobManagePage from "./pages/services/jobs/JobManagePage";
import ProjectLogComponent from "../_metronic/_partials/customComponents/projectLogComponent";
import JobUploadForm from "./pages/forms/jobForms/JobUploadForm";
import HAPLMDataSheet from "./pages/forms/jobForms/HAPLMDataSheet";
import DailyLogForm from "./pages/forms/jobForms/DailyLogForm";
import ACMLogForm from "./pages/forms/jobForms/logs/ACMLogForm";
// JOB FORMS
import AnalysisRequestAndCOCForm from './pages/forms/jobForms/analysis-request-and-coc/AnalysisRequestAndCOCForm';
import SurveyDataSheetForm from './pages/forms/jobForms/survey-datasheet/SurveyDatasheetForm';
import PCMDataSheetForm from './pages/forms/jobForms/datasheet/PCMDataSheetForm';
import LeadAirDataSheetForm from './pages/forms/jobForms/datasheet/LeadAirDataSheetForm';
import LeadPaintChipDataSheetForm from './pages/forms/jobForms/datasheet/LeadPaintChipDataSheetForm';
import LeadTCLPDataSheetForm from './pages/forms/jobForms/datasheet/LeadTCLPDataSheetForm';
import EmployeeAcknowledgementForm from './pages/forms/jobForms/employee-acknowledgement-form/EmployeeAcknowledgementForm';
import ProjectInfoSheet from "./pages/forms/jobForms/ProjectInfoSheet";
import LeadInfoSheet from "./pages/forms/jobForms/LeadInfoSheet";
import PCMCOCForm from "./pages/forms/jobForms/analysis-request-and-coc/PCMCOCForm";
import LeadAirCOCForm from "./pages/forms/jobForms/analysis-request-and-coc/LeadAirCOCForm";
import LeadPaintCOCForm from "./pages/forms/jobForms/analysis-request-and-coc/LeadPaintCOCForm";
import LeadTCLPCOCForm from "./pages/forms/jobForms/analysis-request-and-coc/LeadTCLPCOCForm";
import PLMCOCForm from "./pages/forms/jobForms/analysis-request-and-coc/PLMCOCForm";
import PLMDataSheetForm from "./pages/forms/jobForms/datasheet/PLMDataSheetForm";
import * as userService from "../services/management/userService";
import LeadAirWorkerAcknowledgementForm from "./pages/forms/jobForms/employee-acknowledgement-form/LeadAirWorkerAcknowledgementForm";
import { useAiAccess } from "./AiAccessContext";

export default function BasePage(props) {
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { hasAiAccess, aiAccessLoading } = useAiAccess();

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      if (navigator.geolocation) {
        // if (process.env.REACT_APP_ENVIRONMENT !== "development") {
        userService.validate(position.coords.latitude, position.coords.longitude).then(res => {
          setLoading(false);
        }).catch(ex => {
          history.push('/logout')
        })
        // } else {
        //   setLoading(false);
        // }

      } else {
        history.push('/geo-location-error')
      }
    }, err => {
      history.push('/geo-location-error')
    })
  }, [history]) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    loading ? <></> :
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {
            /* Redirect from root URL to /dashboard. */
            <Redirect exact from="/" to="/dashboard" />
          }
          <ContentRoute path="/log-events" component={LogEventsPage} />
          <ContentRoute path="/dashboard" component={DashboardPage} />
          <ContentRoute path="/management/users" component={UserListingPage} />
          <ContentRoute path="/management/settings" component={SettingListingPage} />
          <ContentRoute path="/management/annual-quotas" component={AnnualQuotaListingPage} />
          <ContentRoute path="/management/year-transition" component={YearTransitionPage} />
          <ContentRoute path="/management/year-allocation-settings" component={YearAllocationSettingsPage} />
          <ContentRoute
            path="/management/ai-documents"
            render={() => aiAccessLoading ? null : hasAiAccess ? <AiDocumentManagerPage /> : <Redirect to="/dashboard" />}
          />
          <ContentRoute exact path="/management/automated-reports" component={AutomatedReportListingPage} />
          <ContentRoute path="/management/add-user" component={UserRegisterPage} />
          <ContentRoute path="/management/user-profile/:userId" component={UserProfilePage} />
          <ContentRoute path="/management/clients" component={ClientListingPage} />
          <ContentRoute path="/management/add-client" component={ClientRegisterPage} />
          <ContentRoute path="/management/pay-rates" component={PayRateListingPage} />
          <ContentRoute path="/management/client-detail/:id" component={ClientDetailPage} />
          <ContentRoute exact path="/management/automated-report/:reportId" component={AutomatedReportDetailPage} />
          <ContentRoute path="/company-data/project-types" component={ProjectTypeListingPage} />
          <ContentRoute path="/company-data/project-sub-types" component={ProjectSubTypeListingPage} />
          <ContentRoute path="/company-data/projects" component={ProjectListingPage} />
          <ContentRoute exact path="/company-data/credential-types" component={TrainingTypesListingPage} />
          <ContentRoute exact path="/company-data/credential-types/:credentialId" component={TrainingSubTypesListingPage} />
          <ContentRoute path="/company-data/interval-types" component={IntervalTypesListingPage} />
          <ContentRoute path="/company-data/referral-sources" component={ReferralSourceListingPage} />
          <ContentRoute path="/company-data/project/edit/:projectId" component={ProjectDetailPage} />
          <ContentRoute path="/company-data/company-calendar" component={CompanyCalendarPage} />

          <ContentRoute path="/reports/time-log-report" component={TimeLogReportPage} />

          <ContentRoute exact path="/training/credentials" component={CredentialsListingPage} />
          <ContentRoute exact path="/training/employee-search" component={EmployeeSearchPage} />
          <ContentRoute path="/training/credentials/edit-credential/:credentialId" component={CredentialDetailPage} />
          <ContentRoute exact path="/training/user-credentials" component={UserCredentialsListing} />
          <ContentRoute path="/training/user-credentials/edit-credential/:credentialId" component={UserCredentialDetailPage} />

          <ContentRoute exact path="/services/proposals" component={ProposalListingPage} />
          <ContentRoute exact path="/services/proposals/add-proposal" component={ProposalDetailPage} />
          <ContentRoute exact path="/services/proposals/edit-proposals/:id" component={ProposalDetailPage} />
          <ContentRoute path="/services/manage-proposal/:id" component={ProposalManagePage} />
          <ContentRoute path="/services/jobs" component={JobListingPage} />
          <ContentRoute path="/services/completed-jobs" component={JobListingCompletedPage} />
          <ContentRoute path="/services/manage-job/:jobId" component={JobManagePage} />

          <ContentRoute exact path="/forms" component={FormListingPage} />
          <ContentRoute path="/forms/job-upload-form/:jobFormId" component={JobUploadForm} />
          <ContentRoute path="/forms/plm-data-sheet/:jobFormId/:edit" component={PLMDataSheetForm} />
          <ContentRoute path="/forms/ha-plm-data-sheet/:jobFormId/:edit" component={HAPLMDataSheet} />
          <ContentRoute path="/forms/daily-log-form/:jobFormId/:edit" component={DailyLogForm} />
          <ContentRoute path="/project-logs" component={ProjectLogComponent} />
          <ContentRoute path="/forms/project-info-sheet/:jobFormId/:edit" component={ProjectInfoSheet} />
          <ContentRoute path="/forms/lead-info-sheet/:jobFormId" component={LeadInfoSheet} />


          <ContentRoute path="/my-time-sheet" component={TimeSheetPage} />
          {/* JOB FORMS */}

          {/* ANALYSIS REQUEST AND COC */}
          <ContentRoute path="/forms/analysis-request-and-coc" component={AnalysisRequestAndCOCForm} />
          <ContentRoute path="/forms/pcm-coc/:jobFormId/:edit" component={PCMCOCForm} />
          <ContentRoute path="/forms/lead-air-coc/:jobFormId/:edit" component={LeadAirCOCForm} />
          <ContentRoute path="/forms/lead-paint-coc/:jobFormId/:edit" component={LeadPaintCOCForm} />
          <ContentRoute path="/forms/lead-tclp-coc/:jobFormId/:edit" component={LeadTCLPCOCForm} />
          <ContentRoute path="/forms/plm-coc/:jobFormId/:edit" component={PLMCOCForm} />

          {/* LOG FORM */ }
          <ContentRoute path="/forms/acm-plm-log/:jobFormId/:edit" component={ACMLogForm} />

          {/* SURVEY DATASHEET */}
          <ContentRoute path="/forms/survey-data-sheet" component={SurveyDataSheetForm} />

          {/* DATA SHEET */}
          <ContentRoute path="/forms/pcm-data-sheet/:jobFormId/:edit" component={PCMDataSheetForm} />
          <ContentRoute path="/forms/lead-air-data-sheet/:jobFormId/:edit" component={LeadAirDataSheetForm} />
          <ContentRoute path="/forms/lead-paint-data-sheet/:jobFormId/:edit" component={LeadPaintChipDataSheetForm} />
          <ContentRoute path="/forms/lead-tclp-data-sheet/:jobFormId/:edit" component={LeadTCLPDataSheetForm} />

          <ContentRoute path="/forms/employee-acknowledgement-form/:jobFormId/:edit" component={EmployeeAcknowledgementForm} />
          <ContentRoute path="/forms/leadAirWorker-acknowledgement-form/:jobFormId/:edit" component={LeadAirWorkerAcknowledgementForm} />
        </Switch>
      </Suspense>
  );
}
